import CRUDService from "./CRUDService";

class ReportCategoryService extends CRUDService {
  constructor() {
    super("report-categories");
  }
}

export default new ReportCategoryService();
